<template>
  <div class="map-component">
    <b-row align-v="end" class="mb-4 g-1" no-gutters v-if="isHeader">
      <b-col cols="12">
        <h4>
          {{ professionTitle ? translations[13591] : translations[6206] }}
          <span v-if="professionTitle">: {{ professionTitle }}</span>
        </h4>
      </b-col>
      <b-col cols="auto">
        <b-button @click="toProfessions()" variant="primary" size="sm" class="position-relative z-3" v-b-tooltip.hover :title="translations[13756]">
          <b-icon icon="chevron-left"></b-icon>
          <span class="ml-1 d-none d-md-inline-block">{{ translations[2901] }}</span>
        </b-button>
      </b-col>
    </b-row>
    <b-overlay
      :show="loading"
      rounded="sm"
      variant="primary"
      :opacity="0.2"
      style="min-height: 200px"
    >
      <GoogleMap ref="mapMarkers" :is-refresh="isRefresh" />
    </b-overlay>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import GoogleMap from '@/components/Map/GoogleMap.vue';
import { ProfessionModule } from '@/store/modules/profession';
import { AppModule } from '@/store/modules/app';
import { MapModule } from '@/store/modules/map';

@Component({
  components: {
    GoogleMap,
  },
})
export default class MapComponent extends Vue {
  @Prop({ default: false }) isHeader!: boolean;

  @Prop({ default: true }) isRefresh!: boolean;

  loading = false;

  get translations() {
    return AppModule.translation;
  }

  get professionTitle() {
    return ProfessionModule.professionTitle;
  }

  toProfessions() {
    AppModule.SetVisibleMap(false);
  }
}
</script>
